import qwest from 'qwest';

import session from './../services/sessionService.jsx';

let WaterEnhancerApi = {
  getBranchEnhancerSummaries(branchIDs, systemType, enhancer, currentStatus) {
    return qwest.post(`/WaterEnhancer/BranchEnhancerSummaries?branchIDs=${branchIDs}&systemType=${systemType}&enhancer=${enhancer}`)
      .then((xhr, res) => {
        return res.data;
      })
      .catch(err => {
        console.error(err);
        throw err;
      });
  },

  updateWaterEnhancers(branchIDs, systemType, enhancer, currentStatus, replacementStatus) {
    return qwest.post('/WaterEnhancer/UpdateWaterEnhancer', {
      branchIDs,
      systemType,
      enhancer,
      currentStatus,
      replacementStatus,
    })
      .then((xhr, res) => {
        if (res.success) {
          return res.data;
        }
        throw res;
      })
      .catch(err => {
        console.error(err);
        return err;
      });
  },
};

export default WaterEnhancerApi;
